import React from "react";
import HelpSectionHeader from "./HelpSectionHeader";
import { guideCards } from "./helpPage.data";
import "./HelpGuideSection.scss";

const HelpGuideSection = () => (
  <section className="help-section help-guide-section">
    <HelpSectionHeader
      eyebrow="Customer care"
      title="What customers usually need"
      text="The page is structured around the same service moments used by jewelry stores: product confidence, care after purchase, and order support."
    />

    <div className="help-guide-grid">
      {guideCards.map((card) => (
        <article className="help-guide-card" key={card.title}>
          <div className="help-guide-card__image">
            <img src={card.image} alt={card.alt} />
          </div>
          <div className="help-guide-card__content">
            <p className="help-label">{card.eyebrow}</p>
            <h3>{card.title}</h3>
            <p>{card.text}</p>
          </div>
        </article>
      ))}
    </div>
  </section>
);

export default HelpGuideSection;
